import { TrialEndWarning } from "@/components/TrialEndWarning/TrialEndWarning";
import { LayoutWorkstationFullscreen } from "@/components/_layouts/LayoutWorkstationFullscreen/LayoutWorkstationFullscreen";
import { LayoutWorkstationSidebar } from "@/components/_layouts/LayoutWorkstationSidebar/LayoutWorkstationSidebar";
import { useDocumentTitle } from "@mantine/hooks";
import { Main } from "./Main/Main";
import { Sidebar } from "./Sidebar/Sidebar";

export const ContactPage = () => {
  useDocumentTitle("ETA IQ - Contact");
  return (
    <LayoutWorkstationFullscreen>
      <TrialEndWarning>
        <LayoutWorkstationSidebar sidebar={<Sidebar />}>
          <Main />
        </LayoutWorkstationSidebar>
      </TrialEndWarning>
    </LayoutWorkstationFullscreen>
  );
};
